import { FilterQuery, FilterTree } from '@monolog/shared/types';

export function buildFilterTree(filters: FilterQuery[]): FilterTree | undefined {
  if (!filters.length) return undefined;
  if (filters.length === 1) return toFilterObject(filters[0]);

  const result: FilterTree[] = [];
  let currentGroup: FilterQuery[] = [filters[0]];
  let currentOperator = filters[1]?.logicalOperator || 'AND';

  for (let i = 1; i < filters.length; i++) {
    const filter = filters[i];
    const op = filter.logicalOperator || 'AND';

    if (op === currentOperator) {
      currentGroup.push(filter);
    } else {
      result.push({
        [currentOperator]: currentGroup.map(toFilterObject),
      } as { AND: FilterTree[] } | { OR: FilterTree[] });
      currentGroup = [filter];
      currentOperator = op;
    }
  }

  if (currentGroup.length === 1) {
    result.push(toFilterObject(currentGroup[0]));
  } else {
    result.push({
      [currentOperator]: currentGroup.map(toFilterObject),
    } as FilterTree);
  }

  let finalTree: FilterTree | undefined;

  if (result.length === 1) {
    finalTree = result[0];
  } else {
    finalTree = { AND: result };
  }

  return finalTree;
}

function toFilterObject(filter: FilterQuery) {
  const { field, operator, value, type } = filter;

  return { field, operator, type, value };
}

export function flattenTreeToFilters(tree: any): FilterQuery[] {
  const result: FilterQuery[] = [];
  let isFirst = true;

  function walk(node: any, operator?: string) {
    if (node.AND || node.OR) {
      const op = node.AND ? 'AND' : 'OR';
      const children = node[op];

      children.forEach((child: any, index: number) => {
        const childOp = isFirst ? undefined : op;
        walk(child, childOp);
        isFirst = false;
      });
    } else {
      result.push({ ...node, logicalOperator: operator });
    }
  }

  walk(tree);

  return result;
}
